import { ChevronDown } from '@aktiia/design-system';
import { forwardRef, useMemo } from 'react';

import { Button } from '../../../../common';
import { IFilterButtonProps } from './types';

const FilterButton = forwardRef<HTMLButtonElement, IFilterButtonProps>(
  ({ text, filters, getText, onClick }: IFilterButtonProps, ref) => {
    const isAnyFilterActive = useMemo(() => {
      return Object.values(filters).some((filter) => !!filter);
    }, [filters]);

    const label = useMemo(() => {
      const filtersActive = Object.keys(filters).filter((key) => !!filters[key]);
      if (!filtersActive.length) {
        return text;
      }
      return getText(filtersActive);
    }, [filters, text]);

    return (
      <Button
        ref={ref}
        text={label}
        type="tertiary"
        size="sm"
        rightIcon={<ChevronDown className="scale-75" />}
        onClick={onClick}
        selected={isAnyFilterActive}
      />
    );
  },
);
FilterButton.displayName = 'FilterButton';

export { FilterButton };
